// assets/theme.js or any global JavaScript file

function openTab(evt, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(tabName).style.display = "block";
  evt.currentTarget.className += " active";
}
// document.addEventListener("DOMContentLoaded", function () {

//     function updatePrices() {
//         let priceElements = document.querySelectorAll(".money");

//         if (!priceElements.length) {
//             console.warn("No price elements found.");
//             return;
//         }

//         priceElements.forEach(function (priceElement) {
//             if (!priceElement || !priceElement.innerText) return; // Ensure element exists

//             let priceText = priceElement.getAttribute("data-currency-inr") || priceElement.innerText.trim();
           

//             // Skip if "Price on request" is already set
//             if (priceText.toLowerCase().includes("price on request")) {
//                 return;
//             }

//             // Extract only numeric values
//             let numericValue = priceText.replace(/[^0-9]/g, "");
//             if (!numericValue) {
//                 return;
//             }

//             let price = parseInt(numericValue, 10);
//             // Replace price if greater than 7 lakh
//             if (!isNaN(price) && price > 700000) {
//                 priceElement.innerText = "Price on request";
//             }
//         });
//     }

//     // Run once on initial page load
//     updatePrices();

//     // Delay execution in case Shopify updates the DOM dynamically
//     setTimeout(updatePrices, 1000);

//     // Handle Shopify AJAX events (for pagination, filters, etc.)
//     document.addEventListener("shopify:section:load", updatePrices);
//     document.addEventListener("shopify:section:reorder", updatePrices);
//     document.addEventListener("shopify:section:select", updatePrices);
//     document.addEventListener("shopify:section:deselect", updatePrices);
//     document.addEventListener("shopify:section:unload", updatePrices);
//     document.addEventListener("shopify:section:change", updatePrices);

//     // Listen for Shopify Infinite Scroll or Pagination
//     document.addEventListener("click", function (event) {
//         if (event.target.closest(".pagination a, .infinite-scroll-button")) {
            
//             setTimeout(updatePrices, 2000); // Wait for new content to load
//         }
//     });

//     // Listen for any new DOM mutations (e.g., AJAX content loading)
//     const observer = new MutationObserver(() => {
//         updatePrices();
//     });

//     observer.observe(document.body, { childList: true, subtree: true });
// });






